import React from 'react';
import { Segment, Button, Icon, Divider } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { getOccupancyForRoom } from '../../../../rooms/occupancy/selectors';
import { getCleaningListToRoom } from '../../../selectors';
const getName = user => {
  return user.surname && user.firstname
    ? `${user.firstname} ${user.surname}`
    : user.email;
};
const getCleaners = (cleanings, users) => {
  const cleaningList = cleanings.map(cleaning => {
    const user = users.find(u => u.userId === cleaning.userId) || {};

    return getName(user);
  });

  if (cleaningList.length === 0) {
    return '';
  }

  return `(${cleaningList.join(', ')})`;
};
const RoomItem = ({
  room,
  handleClick,
  active,
  occupancy,
  cleaningList,
  users
}) => (
  <Segment
    as={Button}
    fluid
    onClick={handleClick}
    color={active ? 'blue' : undefined}>
    <style>{`.ui.button>.icon:not(.button) {
            height: auto;
        }
        #diabled-icon{
          background-color: lightgrey !important;
        }`}</style>
    <span style={{ paddingRight: 20 }}>{room.name}</span>
    {getCleaners(cleaningList, users) !== '' && (
      <span style={{ paddingRight: 20 }}>{`${getCleaners(
        cleaningList,
        users
      )}`}</span>
    )}
    <Icon
      bordered
      name="add user"
      disabled={!occupancy.arrival.occur}
      color={occupancy.arrival.occur ? 'orange' : undefined}
      inverted
      id={!occupancy.arrival.occur ? 'diabled-icon' : undefined}
    />
    <Icon
      bordered
      name="bed"
      disabled={!occupancy.stay.occur}
      inverted
      color={occupancy.stay.occur ? 'blue' : undefined}
      id={!occupancy.stay.occur ? 'diabled-icon' : undefined}
    />

    <Icon
      bordered
      name="remove user"
      inverted
      disabled={!occupancy.departure.occur}
      color={occupancy.departure.occur ? 'orange' : undefined}
      id={!occupancy.departure.occur ? 'diabled-icon' : undefined}
    />
  </Segment>
);

export default connect((state, ownProps) => ({
  occupancy: getOccupancyForRoom(ownProps.room)(state),
  cleaningList: getCleaningListToRoom(ownProps.room)(state),
  users: state.users.data
}))(RoomItem);



// WEBPACK FOOTER //
// ./src/cleaning/schedule/roomPicker/components/RoomItem.js